import pathToRegExp from 'path-to-regexp';
import { capitalizeFirstLetter } from 'helpers/text';
import { getLocationParam } from 'helpers/regex';

const paths = [
  {
    regexp: '/',
    title: 'Recent Activity',
  }, {
    regexp: '/supplies',
    title: 'Supplies',
  }, {
    regexp: '/supplies/new/:id',
    title: 'New Order',
  }, {
    regexp: '/templates',
    title: 'eCOC Templates',
  }, {
    regexp: '/templates/new/:id',
    title: 'New eCOC Templates',
  }, {
    regexp: '/projects/:id/templates/new/:id',
    title: 'New eCOC Templates',
  }, {
    regexp: '/jobs',
    title: 'Jobs',
  }, {
    regexp: '/jobs/:id',
    title: (() => `Job Details - ${getLocationParam('/jobs/:id', 1)}`)(),
  }, {
    regexp: '/search-results',
    title: (() => `Job Details for ${capitalizeFirstLetter(new URLSearchParams(window.location.search).get('searchType') || '')}`)(),
  }, {
    regexp: '/invoices',
    title: 'Invoices',
  }, {
    regexp: '/manage-access/(.*)',
    title: 'Manage Access',
  }, {
    regexp: '/invoices/:id',
    title: 'Invoices',
  }, {
    regexp: '/email-notifications',
    title: 'Email Notifications',
  }, {
    regexp: '/login-as-admin',
    title: 'Login as Admin',
  }, {
    regexp: '/projects/:id',
    title: 'Overview Projects',
  }, {
    regexp: '/site-locations/:id',
    title: 'Overview Site Locations',
  }, {
    regexp: '/projects/:id/:id',
    title: 'Projects with another tab',
  }, {
    regexp: '/site-locations/:id/:id',
    title: 'Site Locations with another tab',
  }, {
    regexp: '/custom-reports',
    title: 'Custom Reports',
  }, {
    regexp: '/my-account',
    title: 'My Account',
  }, {
    regexp: '/resources/:id',
    title: 'Resources',
  }, {
    regexp: '/custom-reports/new/:id',
    title: 'Custom Reports',
  }, {
    regexp: '/privacy',
    title: 'Privacy',
  }, {
    regexp: '/terms',
    title: 'Customer Portal - Terms and Conditions of Use',
  }, {
    regexp: '(.*)',
    title: 'Placeholder',
  },
];

const stepTitleObj = {
  'custom-reports': ['Select Clients', 'Select Date & Format', 'Select Jobs', 'Select Samples',
    'Select Parameters', 'Select Criteria & Generate your Report'],
};

const titleHelper = (object, currentNumber, currentPath) => {
  switch (object.regexp) {
    case '/orders/new/:id':
      return { title: `${currentNumber} - Orders Supplies` };
    case '/custom-reports/new/:id':
      return { title: `Custom Reports - ${stepTitleObj['custom-reports'][currentNumber - 1]}` };
    case '/projects/:id':
    case '/site-locations/:id':
      return { title: currentNumber };
    case '/projects/:id/:id':
    case '/site-locations/:id/:id': {
      let zone = currentPath.replace(/\w/, c => c.toUpperCase());
      if (zone === 'Templates') {
        zone = 'eCOC Templates';
      }

      return { title: `${currentNumber} - ${zone}` };
    }
    default:
      return object;
  }
};

const getMainRoute = (str) => {
  const constList = ['jobs', 'templates', 'invoices', 'supplies', 'custom-reports', 'login', 'resources', 'my-account'];
  const splitPath = str ? str.split('/') : window.location.pathname.split('/');
  if (splitPath.includes('projects')) {
    splitPath.splice(splitPath.indexOf('projects') + 1, 1);
  }
  const hasKnownPath = constList.some(v => splitPath.includes(v));
  let lastNode;
  if (hasKnownPath) {
    const path = constList.filter(element => splitPath.includes(element));
    lastNode = (path.length === 1 ? path[0] : String(splitPath[splitPath.length - 1]));
  } else {
    lastNode = String(splitPath[splitPath.length - 1]);
  }
  if (constList.includes(lastNode)) {
    return lastNode;
  } else if (lastNode === '') {
    return 'overview';
  }
  return lastNode;
};

const getTitle = () => {
  const object = paths.find(path => pathToRegExp(path.regexp).test(window.location.pathname));
  const splitPath = window.location.pathname.split('/');
  if (splitPath.length > 3) {
    if (splitPath.includes('new')) {
      return titleHelper(object, decodeURIComponent(splitPath[3]), splitPath[4]);
    }
    return titleHelper(object, decodeURIComponent(splitPath[2]), splitPath[3]);
  }
  return object;
};

export { getTitle, getMainRoute };



// WEBPACK FOOTER //
// ./src/helpers/title.js